export default class File {
  constructor({
    id,
    linkId,
    url,
    filename,
    type,
    status,
    signedUploadUrl,
    ext,
    label
  }) {
    this.id = id;
    this.linkId = linkId;
    this.url = url;
    this.filename = filename;
    this.type = type || 'video';
    this.status = status;
    this.signedUploadUrl = signedUploadUrl;
    this.ext = ext;
    this.label = label;
  }
}
